
<template>
  <div v-wechat-title="titleTop" :back-level="2">
    <TopBar :pagetitle="title" :back-url="backurl" />
    正在创建订单中,请稍后......
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import request from '@/utils/request'
import { Button, Toast } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, GetSysTitle } from '@/utils/base'
import { GetSelfUrl } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Toast.name]: Toast,
    TopBar
  },
  beforeRouteLeave(to, from, next) {
    Toast.clear()
    next()
  },
  data() {
    return {
      titleTop: GetSysTitle(),
      title: '微信支付',
      backurl: '/store/orderList',
      id: undefined,
      mId: undefined,
      payOrderId: undefined,
      system: undefined,
      data: {}
    }
  },
  created() {
    this.id = this.$route.params.id
    this.system = getUrlKey('system')
    this.mId = getUrlKey('id')
    var payOrderId = getUrlKey('payOrderId')
    if (payOrderId) {
      this.payOrderId = payOrderId
    }
    this.onPay()
  },
  methods: {
    onPay() {
      var my = this
      // console.log('测试', my.data)
      my.doPay((data) => {
        var wxconfig = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.config.appId, // 必填，公众号的唯一标识
          timestamp: Number(data.config.timestamp), // 必填，生成签名的时间戳
          nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
          signature: data.config.signature, // 必填，签名，见附录1
          jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        }
        wx.config(wxconfig)
        wx.ready(function() {
          wx.chooseWXPay({
            appId: data.pay.appId,
            timestamp: data.pay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: data.pay.nonceStr, // 支付签名随机串，不长于 32
            package: data.pay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: data.pay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: data.pay.paySign, // 支付签名
            success: function(res) {
              Toast.success({
                message: '支付成功',
                duration: 3000,
                mask: true,
                forbidClick: false,
                onClose: function() {
                  var url
                  if (my.data.pay.usageType === 'PIC') {
                    url = GetSelfUrl() + 'pic/picInfo/' + my.data.pay.orderId + '?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARD') {
                    url = GetSelfUrl() + 'm/' + my.data.pay.orderId + '?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARDTRIP') {
                    url = GetSelfUrl() + 'divetrip/trip/' + my.data.pay.orderId + '?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARDRESERVE') {
                    url = GetSelfUrl() + 'memberCard/memberCardList?system=' + my.system
                  } else if (my.data.pay.usageType === 'COOLDIVE202111') {
                    url = GetSelfUrl() + 'cooldive/20211111?finish=1&system=' + my.system
                  } else if (my.data.pay.usageType === 'ESIGN_FIND_MERMAID') {
                    url = GetSelfUrl() + 'mermaid/agentList?system=' + my.system
                  } else if (my.data.pay.usageType === 'ESIGN_FIND_MERMAID_SELF') {
                    url = GetSelfUrl() + 'mermaid/mermaidUser?system=' + my.system
                  } else if (my.data.pay.usageType === 'DIVE_ORDER') {
                    url = GetSelfUrl() + 'divetrip?system=' + my.system
                  } else {
                    url = GetSelfUrl() + 'store/payFinish/' + my.id + '?system=' + my.system
                  }
                  window.location.href = url
                  return
                }
              })
            },
            cancel: function(res) { // 提示引用的是mint-UI里toast
              Toast.fail({
                message: '已取消支付',
                duration: 2000,
                mask: true,
                forbidClick: false,
                onClose: function() {
                  var url
                  if (my.data.pay.usageType === 'PIC') {
                    url = GetSelfUrl() + 'pic/picInfo/' + my.data.pay.orderId + '?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARD') {
                    url = GetSelfUrl() + 'm/' + my.data.pay.orderId + '?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARDTRIP') {
                    url = GetSelfUrl() + 'memberCard/memberCardList?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARDRESERVE') {
                    url = GetSelfUrl() + 'memberCard/memberCardList?system=' + my.system
                  } else if (my.data.pay.usageType === 'COOLDIVE202111') {
                    url = GetSelfUrl() + 'cooldive/20211111?pay=1&system=' + my.system
                  } else if (my.data.pay.usageType === 'ESIGN_FIND_MERMAID') {
                    url = GetSelfUrl() + 'mermaid/agentList?system=' + my.system
                  } else if (my.data.pay.usageType === 'ESIGN_FIND_MERMAID_SELF') {
                    url = GetSelfUrl() + 'mermaid/mermaidUser?system=' + my.system
                  } else if (my.data.pay.usageType === 'DIVE_ORDER') {
                    url = GetSelfUrl() + 'divetrip?system=' + my.system
                  } else {
                    url = GetSelfUrl() + 'store/order/' + my.id + '?system=' + my.system
                  }
                  window.location.href = url
                  return
                }
              })
            },
            fail: function(res) {
              Toast.fail({
                message: '支付失败，请重试',
                duration: 3000,
                mask: true,
                forbidClick: false,
                onClose: function() {
                  var url
                  if (my.data.pay.usageType === 'PIC') {
                    url = GetSelfUrl() + 'pic/picInfo/' + my.data.pay.orderId + '?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARD') {
                    url = GetSelfUrl() + 'm/' + my.data.pay.orderId + '?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARDTRIP') {
                    url = GetSelfUrl() + 'memberCard/memberCardList?system=' + my.system
                  } else if (my.data.pay.usageType === 'MEMBERCARDRESERVE') {
                    url = GetSelfUrl() + 'memberCard/memberCardList?system=' + my.system
                  } else if (my.data.pay.usageType === 'COOLDIVE202111') {
                    url = GetSelfUrl() + 'cooldive/20211111?pay=1&system=' + my.system
                  } else if (my.data.pay.usageType === 'ESIGN_FIND_MERMAID') {
                    url = GetSelfUrl() + 'mermaid/agentList?system=' + my.system
                  } else if (my.data.pay.usageType === 'ESIGN_FIND_MERMAID_SELF') {
                    url = GetSelfUrl() + 'mermaid/mermaidUser?system=' + my.system
                  } else if (my.data.pay.usageType === 'DIVE_ORDER') {
                    url = GetSelfUrl() + 'divetrip?system=' + my.system
                  } else {
                    url = GetSelfUrl() + 'store/order/' + my.id + '?system=' + my.system
                  }
                  window.location.href = url
                  return
                }
              })
            }
          })
        })
      })
    },
    doPay(callback) {
      request({
        url: '/data/payCreate',
        method: 'post',
        data: {
          orderId: this.id,
          payOrderId: this.payOrderId,
          url: location.href.split('#')[0]
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        if (callback) {
          callback(response.data)
        }
      })
    }
  }
}
</script>
